<div *ngIf='entry.numEntries === 2' class="selectentry">
    <button type="button" class="btn btn-secondary btn-block" [class.btn-danger]="firstHighlight()" 
        (click)='selectLeft()'>Select Left</button>
    <button type="button" class="btn btn-secondary btn-block" [class.btn-danger]="secondHighlight()" 
        (click)='selectRight()'>Select Right</button>
    <button *ngIf='showRejectButton' type="button" class="btn btn-secondary btn-block" [class.btn-danger]="neitherHighlight()" 
        (click)='selectNeither()'>Reject Both</button>
</div>
<div *ngIf='entry.numEntries === 1' class="selectentry">
    <button type="button" class="btn btn-secondary btn-block" [class.btn-danger]="firstHighlight()" 
        (click)='selectLeft()'>Select</button>
    <button *ngIf='showRejectButton' type="button" class="btn btn-secondary btn-block" [class.btn-danger]="neitherHighlight()" 
        (click)='selectNeither()'>Reject</button>
</div>